import type { WaitlistWidgetTemplate } from '@/features/widget-setup/types';

export interface WaitlistTemplateDefinition {
  id: WaitlistWidgetTemplate;
  label: string;
  description: string;
  width: 'narrow' | 'wide';
  badge?: string;
}

export const WAITLIST_WIDGET_TEMPLATES: WaitlistTemplateDefinition[] = [
  {
    id: 'centered',
    label: 'Centered Classic',
    description: 'Modern SaaS with gradient bg, pill badge, and colored shadow.',
    width: 'narrow',
  },
  {
    id: 'minimal',
    label: 'Minimal',
    description: 'Ultra-compact notify bar with joined email+button pill.',
    width: 'narrow',
  },
  {
    id: 'card',
    label: 'Floating Card',
    description: 'Glassmorphism card with gradient header and floating orbs.',
    width: 'narrow',
  },
  {
    id: 'split',
    label: 'Split View',
    description: 'Bold gradient left panel with social proof, clean form right.',
    width: 'wide',
  },
  {
    id: 'launch_card',
    label: 'Launch Card',
    description: 'Dark neon launch announcement with developer noir aesthetics.',
    width: 'narrow',
    badge: 'New',
  },
  {
    id: 'dark_premium',
    label: 'Dark Premium',
    description: 'Luxury dark theme with serif typography and refined accents.',
    width: 'narrow',
    badge: 'New',
  },
  {
    id: 'social_proof',
    label: 'Social Proof',
    description: 'Trust-driven design with avatars, live counters, and testimonials.',
    width: 'narrow',
    badge: 'New',
  },
];

export const DEFAULT_WAITLIST_TEMPLATE: WaitlistWidgetTemplate = 'centered';

export function getWaitlistTemplateDefinition(template: WaitlistWidgetTemplate): WaitlistTemplateDefinition {
  return WAITLIST_WIDGET_TEMPLATES.find((item) => item.id === template)
    ?? WAITLIST_WIDGET_TEMPLATES[0];
}

